import { render } from "./medicalprescription.vue?vue&type=template&id=15228089"
import script from "./medicalprescription.vue?vue&type=script&lang=js"
export * from "./medicalprescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__